module.exports = __webpack_public_path__ + "static/media/screen4-2x.e1291b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Phone/screen4-2x.jpg
// module id = 50
// module chunks = 0